import React, {useMemo, useRef, useState} from 'react';
import {Divider, Radio, Select, Space} from "antd";
import {useAuth} from "../providers/AuthProvider";
import SearchBoxNew from "./test/SearchBox";
import {CloseOutlined} from "@ant-design/icons";

const TalentLocationRadioSelect = ({onlyProximity, isDisabled, onChange, label, value, regions = [], proximity = {}, ...props}) => {
    const {client_org_regions, auth} = useAuth();
    const valueMixed = value ? (value > 3 ? 4 : value) : undefined;
    const locationMileContainer = useRef(null);
    const locationRegionContainer = useRef(null);

    const [locationFormModel, setLocationFormModel] = useState(proximity?.latitude ? proximity : {})
    const locationMileSetting = useMemo(() => {
        let setting = laravel.project_visibility_location_settings?.[value];

        if (setting && setting.includes('Within')) {
            return parseInt(setting.replace(/^\D+/g, ''))
        }
        return 200
    }, [value, valueMixed]);

    const locationRegionSetting = useMemo(() => {
        if (valueMixed !== TB.locationRegionalSetting() || !regions.length) {
            return [];
        }


        let selectedRegions = TB.filter(client_org_regions, region => regions.includes(region.id))
        return TB.map(selectedRegions, 'id')
    }, [value, valueMixed, regions, client_org_regions]);

    const availableRegionOptions = useMemo(() => {
        let regions = TB.orderBy(client_org_regions || [], ['display_index'], ['asc']);
        regions = TB.filter(regions, region => region.name !== 'All Other Countries')
        return TB.map(regions, region => ({label: region.name, value: region.id}))
    }, [client_org_regions])

    // console.log('TalentLocationRadioSelect', client_org_regions, locationRegionSetting)
    const onLocationChange = (e) => {
        if (e.target.value === TB.locationRegionalSetting()) {
            let defaultRegion = TB.first(availableRegionOptions);
            onChange({
                location: e.target.value,
                regions: [defaultRegion?.value],
                latitude: null,
                longitude: null,
                address: null
            });
            // let defaultRegion = TB.first(availableRegionOptions);
            // onChange({
            //     location: e.target.value,
            //     regions: [defaultRegion.value],
            //     latitude: null,
            //     longitude: null
            // });
        } else if (e.target.value <= 2) {
            onChange({
                location: e.target.value,
                regions: [],
                latitude: null,
                longitude: null,
                address: null
            });
        } else {
            onChange({
                location: parseInt(TB.invert(laravel.project_visibility_location_settings)[`Within ${locationMileSetting} Miles`]),
                regions: [],
                latitude: locationFormModel?.latitude,
                longitude: locationFormModel?.longitude,
                address: locationFormModel.full
            })
        }
    };

    return (
        <Radio.Group className="self-stretch block" onChange={onLocationChange} disabled={isDisabled}
                     value={valueMixed ? parseInt(valueMixed) : undefined}>
            <Space className="items-stretch flex" direction="vertical">

                <Radio disabled={isDisabled}
                       value={TB.locationGlobalSetting()}>
                    Global
                </Radio>

                <Radio disabled={isDisabled}
                       value={TB.locationRegionalSetting()}>
                    US-Only
                </Radio>

                <div className="flex flex-col items-stretch justify-start gap-1.5">
                    <div className="flex flex-row items-center justify-start gap-2.5" ref={locationMileContainer}>
                        {!onlyProximity ? (
                            <Radio value={4} disabled={isDisabled} className="m-0 mr-[-8px]">
                                By Proximity
                            </Radio>
                        ) : (
                            <p className="m-0">
                                By Proximity
                            </p>
                        )}
                    </div>
                    {valueMixed > 3 && (
                        <React.Fragment>
                            <Divider className="my-2"/>

                            <div
                                className="location-talent-search mb-3 bg-white border-secondary border px-2 py-2 self-stretch flex flex-col gap-3 relative">
                                <div className="flex flex-col items-start gap-3">
                                    <p className="m-0 font-semibold text-sm">
                                        Distance:
                                    </p>
                                    <Select
                                        className="pointer-events-all m-0"
                                        defaultValue={200}
                                        value={locationMileSetting}
                                        getPopupContainer={() => locationMileContainer?.current}
                                        disabled={valueMixed <= 3}
                                        style={{width: 110}}
                                        onChange={(value) => {
                                            return onChange({
                                                location: parseInt(TB.invert(laravel.project_visibility_location_settings)[`Within ${value} Miles`]),
                                                countries: [],
                                                latitude: locationFormModel?.latitude,
                                                longitude: locationFormModel?.longitude,
                                                address: locationFormModel?.full
                                            })
                                        }}
                                        options={[
                                            {
                                                value: 25,
                                                label: '25 Miles',
                                            },
                                            {
                                                value: 50,
                                                label: '50 Miles',
                                            },
                                            {
                                                value: 100,
                                                label: '100 Miles',
                                            },
                                            {
                                                value: 200,
                                                label: '200 Miles',
                                            },
                                        ]}
                                    />
                                    {/*<p className="m-0 font-semibold text-sm">*/}
                                    {/*    of*/}
                                    {/*</p>*/}
                                </div>
                                <div className="flex flex-col items-stretch gap-3">
                                    <p className="m-0 font-semibold text-sm">
                                        Location:
                                    </p>
                                    <div className="border border-gray-200 px-2.5 pb-2 text-xs flex flex-col items-stretch">
                                        {locationFormModel?.full ? (
                                            <div className="self-stretch pt-2 flex flex-row justify-between relative">

                                                <p className="text-sm line-clamp-1 flex-grow max-w-[95%]">
                                                    {locationFormModel?.full}
                                                </p>

                                                <CloseOutlined style={{fontSize: 12}} className="clickable px-2"
                                                               onClick={e => {
                                                                   setLocationFormModel({})
                                                                   onChange({latitude: null, longitude: null})
                                                               }}/>
                                            </div>
                                        ) : (
                                            <SearchBoxNew
                                                searchHint="Search for a city"
                                                token={'pk.eyJ1Ijoia2VpdGh3cmlwcGxlIiwiYSI6ImNsNTMxN2d4MTAxbTYzcW1mZmhnaW96eXkifQ.6LoANVf0-IcjzWSrZSPt3A'}
                                                // country="US"
                                                callback={({location, event}) => {
                                                    let parts = {};
                                                    for (let part of location.context) {
                                                        let key = part.id.split('.')[0];
                                                        let value = part.text;
                                                        if (key == 'country' && part.short_code) {
                                                            parts.country_name = value;
                                                            value = part.short_code.toUpperCase();
                                                        }
                                                        parts[key] = value;

                                                    }
                                                    if (!parts.country) {
                                                        return TB.toast("Invalid location selected", {theme: 'danger'});
                                                    }
                                                    let city = location.place_name.replace(', ' + parts.country_name, '');
                                                    if (parts.region) {
                                                        city = city.replace(', ' + parts.region, '');
                                                    }
                                                    let formatted = {
                                                        full: location.place_name,
                                                        city,
                                                        country: parts.country,
                                                        state: parts.region,
                                                        longitude: location.center[0],
                                                        latitude: location.center[1],
                                                        address: location?.place_name
                                                    };
                                                    // console.log({location, event, formatted})

                                                    setLocationFormModel(formatted);

                                                    onChange({
                                                        latitude: formatted.latitude,
                                                        longitude: formatted.longitude,
                                                        address: formatted.address
                                                    })

                                                    // location object from mapbox
                                                    // event onMouseDown supplied if suggestion clicked
                                                }}
                                                selectColor="#5F3DB1"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>


                        </React.Fragment>

                    )}
                </div>

                {/*<div className="flex flex-col items-stretch justify-start gap-1.5" ref={locationRegionContainer}>*/}
                {/*    {!onlyProximity ? (*/}
                {/*        <Radio value={TB.locationRegionalSetting()} disabled={isDisabled} className="m-0 mr-[-8px]">*/}
                {/*            By Region*/}
                {/*        </Radio>*/}
                {/*    ) : (*/}
                {/*        <p className="m-0">*/}
                {/*            By Region*/}
                {/*        </p>*/}
                {/*    )}*/}
                {/*    {valueMixed === TB.locationRegionalSetting() && (*/}
                {/*        <React.Fragment>*/}
                {/*            <Divider className="my-2"/>*/}
                {/*            <Checkbox.Group value={locationRegionSetting}*/}
                {/*                            className="pointer-events-all mb-3 bg-white border-secondary border px-2 py-2 self-stretch"*/}
                {/*                            onChange={(values) => {*/}
                {/*                                let selectedRegions = TB.filter(client_org_regions, region => values.includes(region.id));*/}

                {/*                                return onChange({regions: TB.map(selectedRegions, 'id')})*/}
                {/*                            }}>*/}
                {/*                <Space direction="vertical">*/}
                {/*                    {TB.map(availableRegionOptions, option => {*/}
                {/*                        return (*/}
                {/*                            <Checkbox key={`region-${option.value}`} value={option.value}*/}
                {/*                                      disabled={valueMixed !== TB.locationRegionalSetting()}>*/}
                {/*                        <span className="text-sm">*/}
                {/*                            {option.label}*/}
                {/*                        </span>*/}
                {/*                            </Checkbox>*/}
                {/*                        )*/}
                {/*                    })}*/}
                {/*                </Space>*/}
                {/*            </Checkbox.Group>*/}
                {/*        </React.Fragment>*/}

                {/*    )}*/}
                {/*</div>*/}
            </Space>
        </Radio.Group>
    )
};

export default TalentLocationRadioSelect;